import { createIdByParams } from './utils';

export const membersListActions = {

  FETCH_MEMBERS_FAILED: 'FETCH_MEMBERS_FAILED',
  FETCH_MEMBERS_SUCCESS: 'FETCH_MEMBERS_SUCCESS',
  FETCH_MEMBERS_PENDING: 'FETCH_MEMBERS_PENDING',

  FIND_MEMBERS:'FIND_MEMBERS',
  FIND_MEMBERS_BY_ID:'FIND_MEMBERS_BY_ID',

  fetchMembersFailed: error => ({
    type: membersListActions.FETCH_MEMBERS_FAILED,
    payload: error
  }),

  fetchMembersSuccess: (membersListId, data) => ({
    type: membersListActions.FETCH_MEMBERS_SUCCESS,
    payload: {
      data,
      membersListId
    }
  }),

  fetchMembersPending: membersListId => ({
    type: membersListActions.FETCH_MEMBERS_PENDING,
    payload: {
      membersListId
    }
  }),

  findMembers: (filters = { name: '' }) => ({
    type: membersListActions.FIND_MEMBERS,
    payload: {
      membersListId: createIdByParams(filters),
      filters: {
        ...filters,
        name: filters?.name ? filters?.name.trim() : ''
      }
    }
  }),

  findMembersById: (membersListId) => ({
    type: membersListActions.FIND_MEMBERS_BY_ID,
    payload: {
      membersListId:  `${membersListId}`,
    }
  }),
};


export const membersListRequestActions = {
  failed: membersListActions.fetchMembersFailed,
  success: membersListActions.fetchMembersSuccess,
  pending: membersListActions.fetchMembersPending
};
